import { Alert, Text } from '@mantine/core';
import { IconPaperclip } from '@tabler/icons';

const AttachmentsAlert = () => (
  <Alert
    icon={<IconPaperclip color="white" />}
    title={<Text color="white">Anhänge werden nicht mitgesendet</Text>}
    sx={(theme) => ({ backgroundColor: theme.colors.orange[3] })}
    mb="xs"
  >
    <Text color="white">Anhänge werden in dieser E-Mail nicht unterstützt. Du kannst die E-Mail trotzdem senden, aber die Anhänge werden nicht berücksichtigt.</Text>
  </Alert>
);

export default AttachmentsAlert;
